import { Box, Card, Divider, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

export interface SectionCardProps {
  readonly title: string;
  /** Optional node rendered on the right of the header (button, chip, badge). */
  readonly action?: ReactNode;
  readonly children: ReactNode;
  /** Removes the inner content padding (useful for full-bleed lists/tables). */
  readonly disableContentPadding?: boolean;
}

/**
 * Dense panel with a titled header bar + divider, matching the VSO card
 * pattern. Pure CDS/MUI — all spacing/typography/colors are theme-driven.
 */
export function SectionCard({
  title,
  action,
  children,
  disableContentPadding = false,
}: SectionCardProps) {
  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          px: (theme) => theme.spacing(2),
          py: (theme) => theme.spacing(1.5),
          gap: (theme) => theme.spacing(1),
        }}
      >
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        {action}
      </Stack>
      <Divider />
      <Box
        sx={{
          flex: '1 1 auto',
          p: (theme) => (disableContentPadding ? 0 : theme.spacing(2)),
        }}
      >
        {children}
      </Box>
    </Card>
  );
}
